var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-flex",
        [
          _c(
            "v-card-text",
            { staticClass: "background darken-1" },
            [
              _c(
                "v-text-field",
                {
                  attrs: {
                    solo: "",
                    loading: _vm.suifaInfos.loading,
                    name: "name",
                    label: "Référence suifa",
                    id: "id",
                    "hide-details": ""
                  },
                  on: {
                    input: function($event) {
                      return _vm.getBehiveAssetInfo($event)
                    }
                  },
                  model: {
                    value: _vm.suifaRef,
                    callback: function($$v) {
                      _vm.suifaRef = $$v
                    },
                    expression: "suifaRef"
                  }
                },
                [
                  _c(
                    "v-tooltip",
                    { attrs: { slot: "append", bottom: "" }, slot: "append" },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            slot: "activator",
                            icon: "",
                            small: "",
                            disabled: _vm.suifaInfos.loading
                          },
                          on: {
                            click: function($event) {
                              return _vm.getBehiveAssetInfo(_vm.suifaRef)
                            }
                          },
                          slot: "activator"
                        },
                        [
                          _vm.suifaInfos.loading
                            ? _c(
                                "span",
                                [
                                  _c("v-progress-circular", {
                                    attrs: {
                                      indeterminate: "",
                                      size: 35,
                                      width: 5
                                    }
                                  })
                                ],
                                1
                              )
                            : _c(
                                "span",
                                [
                                  _c("v-icon", [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\tyoutube_searched_for\n\t\t\t\t\t\t\t"
                                    )
                                  ])
                                ],
                                1
                              )
                        ]
                      ),
                      _vm._v("\n\t\t\t\t\tGet data from Behive/Suifa\n\t\t\t\t")
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.errors
                ? _c(
                    "div",
                    _vm._l(_vm.errors, function(error) {
                      return _c(
                        "p",
                        { key: error.id, staticClass: "error--text" },
                        [_vm._v("\n\t\t\t\t\t" + _vm._s(error) + "\n\t\t\t\t")]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.suifaInfos.data && _vm.suifaInfos.data.t_aux_proprio
                ? _c("div", { staticClass: "mt-2" }, [
                    _vm.suifaInfos.data.t_aux_proprio.t_libelle ||
                    _vm.suifaInfos.data.t_aux_proprio.t_auxiliaire
                      ? _c("p", { staticClass: "mb-1" }, [
                          _c("strong", { staticClass: "primary--text" }, [
                            _vm._v("Ayant droit :")
                          ]),
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(
                                _vm.suifaInfos.data.t_aux_proprio.t_libelle
                              ) +
                              " - (" +
                              _vm._s(
                                _vm.suifaInfos.data.t_aux_proprio.t_auxiliaire
                              ) +
                              ")\n\t\t\t\t"
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "p",
                      { staticClass: "m-0" },
                      [
                        _c("strong", { staticClass: "primary--text" }, [
                          _vm._v("Asset :")
                        ]),
                        _vm._v(" "),
                        _vm.suifaInfos.data.type_sup.code_type_sup
                          ? _c(
                              "v-chip",
                              {
                                staticClass: "mx-0",
                                attrs: { small: "", label: "" }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.suifaInfos.data.type_sup.code_type_sup
                                    ) +
                                    "\n\t\t\t\t\t"
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.suifaInfos.data.titre.titre_princ
                          ? _c("span", { staticClass: "mb-1" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.suifaInfos.data.titre.titre_princ
                                  ) +
                                  "\n\t\t\t\t\t"
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("strong", [
                          _vm.suifaInfos.data.asset_size &&
                          String(_vm.suifaInfos.data.asset_size).length < 10
                            ? _c("span", { staticClass: "mb-1" }, [
                                _vm._v(
                                  "\n\t\t\t\t\t\t-\n\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$weight.bitRoundToTwo(
                                        _vm.suifaInfos.data.asset_size,
                                        2
                                      )
                                    ) +
                                    " Mo\n\t\t\t\t\t\t"
                                )
                              ])
                            : _vm.suifaInfos.data.asset_size
                            ? _c("span", { staticClass: "mb-1" }, [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$weight.bitRoundToTwo(
                                        _vm.suifaInfos.data.asset_size,
                                        3
                                      )
                                    ) +
                                    " Go\n\t\t\t\t\t\t"
                                )
                              ])
                            : _vm._e()
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.suifaInfos.data.type_sup.code_type_sup
                      ? _c("p", { staticClass: "mb-1" }, [
                          _c("strong", { staticClass: "primary--text" }, [
                            _vm._v("Contrat :")
                          ]),
                          _vm._v(" "),
                          this.localHasContract
                            ? _c("span", [_vm._v("Oui")])
                            : _c("span", [_vm._v("Non")])
                        ])
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.suifaInfos.data &&
              _vm.suifaInfos.data.cpls &&
              _vm.suifaInfos.data.cpls.length > 0
                ? _c(
                    "div",
                    { staticClass: "mt-3" },
                    [
                      _c("h6", [
                        _c("strong", { staticClass: "primary--text" }, [
                          _vm._v("Liste des DCP :")
                        ])
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.suifaInfos.data.cpls, function(cpls) {
                        return _c(
                          "div",
                          { key: cpls.id },
                          [
                            _c(
                              "v-chip",
                              {
                                staticClass: "mx-0 w-45",
                                attrs: { label: "", small: "" }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(cpls.folder_type) +
                                    "\n\t\t\t\t\t"
                                )
                              ]
                            ),
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s(cpls.folder_name) +
                                "\n\t\t\t\t\t"
                            ),
                            cpls.folder_size > 0
                              ? _c("span", [
                                  _vm._v("\n\t\t\t\t\t\t-\n\t\t\t\t\t\t"),
                                  String(cpls.folder_size).length < 10
                                    ? _c("span", [
                                        _c("strong", [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                _vm.$weight.bitRoundToTwo(
                                                  cpls.folder_size,
                                                  2
                                                )
                                              ) +
                                              " Mo\n\t\t\t\t\t\t\t"
                                          )
                                        ])
                                      ])
                                    : _c("span", [
                                        _c("strong", [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                _vm.$weight.bitRoundToTwo(
                                                  cpls.folder_size,
                                                  3
                                                )
                                              ) +
                                              " Go\n\t\t\t\t\t\t\t"
                                          )
                                        ])
                                      ])
                                ])
                              : cpls.folder_taille > 0
                              ? _c("span", [
                                  _vm._v("\n\t\t\t\t\t\t-\n\t\t\t\t\t\t"),
                                  String(cpls.folder_taille).length < 10
                                    ? _c("span", [
                                        _c("strong", [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                _vm.$weight.bitRoundToTwo(
                                                  cpls.folder_taille,
                                                  2
                                                )
                                              ) +
                                              " Mo\n\t\t\t\t\t\t\t"
                                          )
                                        ])
                                      ])
                                    : _c("span", [
                                        _c("strong", [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                _vm.$weight.bitRoundToTwo(
                                                  cpls.folder_taille,
                                                  3
                                                )
                                              ) +
                                              " Go\n\t\t\t\t\t\t\t"
                                          )
                                        ])
                                      ])
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          !_vm.errors.length && this.suifaInfos.data
            ? _c(
                "v-card-actions",
                {},
                [
                  _c("v-select", {
                    attrs: {
                      dense: "",
                      flat: "",
                      "prepend-inner-icon": "archive",
                      items: _vm.stockageList,
                      label: "Type de stockage"
                    },
                    model: {
                      value: _vm.storageType,
                      callback: function($$v) {
                        _vm.storageType = $$v
                      },
                      expression: "storageType"
                    }
                  }),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c("v-switch", {
                    staticClass: "switch-label",
                    attrs: { color: "primary", label: "Supprimer la source" },
                    model: {
                      value: _vm.removeSource,
                      callback: function($$v) {
                        _vm.removeSource = $$v
                      },
                      expression: "removeSource"
                    }
                  }),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "mr-0",
                      attrs: {
                        disabled: _vm.disableSubmitButton,
                        color: "primary color--text",
                        loading: _vm.submitLoading
                      },
                      on: {
                        click: function($event) {
                          _vm.submit()
                          _vm.$emit("close")
                        }
                      }
                    },
                    [_vm._v("\n\t\t\t\tEnvoyer\n\t\t\t")]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6abf6909", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6abf6909","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/pages/maestro/jobs/launcher/job_launcher_form_dcp.vue
// module id = null
// module chunks = 